import axiosInstance from "../axios/axios";

const bidList = async (body) => {
  try {
    const response = await axiosInstance.post("/bid/getAllBids", body); // replace with your endpoint
    //console.log("bidList--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching bidList:", error);
  }
};
const getCatogeryById = async (categoryId) => {
  try {
    //console.log("getCatogeryById===>", categoryId);
    const response = await axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`
    ); // replace with your endpoint
    //console.log("getCatogeryById--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getCatogeryById:", error);
  }
};
const getAllAgent = async () => {
  try {
    const response = await axiosInstance.get(`/Agent/getAllAgents`); // replace with your endpoint
    //console.log("getAllAgent--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllAgent:", error);
  }
};
const getBidById = async (id) => {
  console.log("getBidById===>", id);
  try {
    const response = await axiosInstance.get(`/bid/getBidById/${id}`); // replace with your endpoint
    //console.log("getBidById--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getBidById:", error);
  }
};

const addBid = async (userId, companyId, body) => {
  //console.log("addBid===>", userId, companyId, body);
  try {
    debugger;
    const response = await axiosInstance.post(
      `/bid/addBid/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addBid--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addBid:", error);
  }
};
const updateBid = async (userId, companyId, body) => {
  // console.log(
  //   "updateBid===>",
  //   userId,
  //   companyId,
  //   bidId,
  //   bidDate,
  //   bidDueDate,
  //   contractExptStartDate,
  //   bidRemark
  // );
  try {
    debugger;
    // const response = await axiosInstance.post(
    //   `/bid/updateBids/${userId}/${companyId}/${bidId}/${bidDate}/${bidDueDate}/${contractExptStartDate}/${bidRemark}`
    // ); // replace with your endpoint
    //console.log("updateBid--->", response?.data);
    const response = await axiosInstance.post(
      `/bid/updateBids/${userId}/${companyId}`,
      body
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBid:", error);
  }
};
const getBidEntities = async (bidId) => {
  try {
    const response = await axiosInstance.get(
      `/bidEntity/getAllBidEntities/${bidId}`
    ); // replace with your endpoint
    //console.log("getBidEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getBidEntities:", error);
  }
};
const getBidAnnualEntities = async (bidId) => {
  try {
    const response = await axiosInstance.get(
      `/bidEntity/getAllBidEntities/${bidId}`
    ); // replace with your endpoint
    //console.log("getBidAnnualEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getBidAnnualEntities:", error);
  }
};

const addBidEntity = async (userId, companyId, body) => {
  try {
    //console.log("addBidEntity===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/bidEntity/addBidEntity/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addBidEntity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addBidEntity:", error);
  }
};
const getEntityConsumptionHeaderByBidId = async (leadId) => {
  //console.log("getEntityConsumptionHeaderByBidId===>", leadId);
  try {
    const response = await axiosInstance.get(
      `/bidEntity/getEntityConsumptionHeaderByBidId/${leadId}`
    ); // replace with your endpoint
    //console.log("getEntityConsumptionHeaderByBidId--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getEntityConsumptionHeaderByBidId:", error);
  }
};
const getAllSuppliersInfoByBidId = async (id) => {
  //console.log("getAllSuppliersInfoByBidId===>", id);
  try {
    const response = await axiosInstance.get(
      `/bid/getAllSuppliersInfoByBidId/${id}`
    ); // replace with your endpoint
    //console.log("getAllSuppliersInfoByBidId--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllSuppliersInfoByBidId:", error);
  }
};
const getAllSuppliers = async (id) => {
  //console.log("getAllSuppliers===>", id);
  //getAllSuppliers / { id }
  try {
    const response = await axiosInstance.get(`/Supplier/getAllSuppliers/${id}`); // replace with your endpoint
    //console.log("getAllSuppliers--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllSuppliers:", error);
  }
};
const getBidSupplierPriceLog = async (bidId, supplierId, billingTypeId) => {
  //console.log("getBidSupplierPriceLog===>", bidId, supplierId);
  try {
    const response = await axiosInstance.get(
      `/bid/getBidSupplierPriceLog/${bidId}/${supplierId}/${billingTypeId}`
    ); // replace with your endpoint
    //console.log("getBidSupplierPriceLog--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getBidSupplierPriceLog:", error);
  }
};
const updateBidSupplierComment = async (
  supplierInfoId,
  userId,
  companyId,
  notes
) => {
  try {
    const response = await axiosInstance.post(
      `/bid/updateBidSupplierComment/${supplierInfoId}/${userId}/${companyId}`,
      notes
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBidSupplierComment:", error);
  }
};
const updateBidInternalComment = async (
  supplierInfoId,
  userId,
  companyId,
  notes
) => {
  try {
    const response = await axiosInstance.post(
      `/bid/updateBidInternalComment/${supplierInfoId}/${userId}/${companyId}`,
      notes
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBidInternalComment:", error);
  }
};
const updateBidCustomerComment = async (
  supplierInfoId,
  userId,
  companyId,
  notes
) => {
  try {
    const response = await axiosInstance.post(
      `/bid/updateBidCustomerComment/${supplierInfoId}/${userId}/${companyId}`,
      notes
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBidCustomerComment:", error);
  }
};
const getAnnualEntityConsumptionByBidId = async (bidId) => {
  try {
    const response = await axiosInstance.get(
      `/bidEntity/getAnnualEntityConsumptionByBidId/${bidId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getAnnualEntityConsumptionByBidId:", error);
  }
};
const updateBidEntity = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/bidEntity/updateBidEntity/${userId}/${companyId}`,
      body
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBidEntity:", error);
  }
};
// const publishBid = async (userId, companyId, bidId, bidDealer, supplierIds, recipient, emailBody, subject, fromEmailId, ccEmailId, body) => {
//   try {
//     debugger;
//     // `/bid/publishBid/${userId}/${companyId}?bidId=${bidId}&bidDealer=${bidDealer}&supplierIds=${supplierIds}&recipient=${recipient}&emailBody=${emailBody}&subject=${subject}&fromEmailId=${fromEmailId}&ccEmailId=${ccEmailId}`,
//     const response = await axiosInstance.post(
//       `/bid/publishBid/1/1?bidId=50&bidDealer=Mike%20Prendergast&supplierIds=1&supplierIds=2&recipient=mshekhani%40plexitech.com&emailBody=%3Cp%3EGreetings%2C%3C%2Fp%3E%3Cp%3ESlattery%20Energy%20invites%20you%20to%20participate%20in%20the%20master%20%3Cstrong%3EFirm%20Gas%3C%2Fstrong%3E%20bid%20for%20%3Cstrong%3ESlick%20Watts%3C%2Fstrong%3E.%20Please%20find%20details%20and%20bid%20requirements%20below.%3C%2Fp%3E%3Cp%3E%3Cstrong%3EBid%20Requirements%3A%3C%2Fstrong%3E%3C%2Fp%3E%20%3Cul%3E%3Cli%3EPricing%20to%20include%20all%20charges%3A%20POR%2C%20losses%2C%20load%20following%2C%20DDS%2C%20WBS%2C%20100%25%20swing%2C%20etc.%3C%2Fli%3E%20%3Cli%3ESupplier%20to%20furnish%20a%20schedule%20of%2012%20of%20usage%20by%20account%20in%20Excel%20format.%3C%2Fli%3E%3Cli%3ESupplier%20will%20allow%20Client%20to%20Blend%20and%20Extend%20contracted%20rate.%3C%2Fli%3E%20%3Cli%3EPricing%20to%20be%20submitted%20via%20email%20in%20%24%2Ftherm.%3C%2Fli%3E%20%3C%2Ful%3E%20%3Cp%3E%3Cstrong%3ESpecifics%3A%3C%2Fstrong%3E%3C%2Fp%3E%20%3Cul%3E%20%20%20%3Cli%3E%3Cstrong%3EDue%20Date%3A%3C%2Fstrong%3E%20%3Cstrong%3E10-31-2025%3C%2Fstrong%3E%3C%2Fli%3E%3Cli%3E%3Cstrong%3EStart%20Date%3A%3C%2Fstrong%3E%20%3Cstrong%3E10-31-2025%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3ETerms%3A%3C%2Fstrong%3E%20%3Cstrong%3E%20%201%20Month%2C%202%20Months%20%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EProduct%20Type%3A%3C%2Fstrong%3E%20%3Cstrong%3EFixed%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EProduct%3A%3C%2Fstrong%3E%20%3Cstrong%3EFirm%20Gas%3C%2Fstrong%3E%3C%2Fli%3E%3Cli%3E%3Cstrong%3EUtility%3A%3C%2Fstrong%3E%20%3Cstrong%3EConEd%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EEstimated%20portfolio%20volume%3A%3C%2Fstrong%3E%20%3Cstrong%3E12332%20Therms%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EFee%3A%3C%2Fstrong%3E%20TBD%3C%2Fli%3E%20%3C%2Ful%3E%20%20%3Cp%3E%3Cstrong%3EContract%20Signatory%20Information%3A%3C%2Fstrong%3E%3C%2Fp%3E%20%20%3Cul%3E%20%3Cli%3E%3Cstrong%3ESignatory%3A%3C%2Fstrong%3E%20%3Cstrong%3E185%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EAddress%3A%3C%2Fstrong%3E%20%3Cstrong%3E10%20E%2016th%20Street%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3ECity%3A%3C%2Fstrong%3E%20%3Cstrong%3ENew%20York%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EState%3A%3C%2Fstrong%3E%20%3Cstrong%3ENew%20York%3C%2Fstrong%3E%3C%2Fli%3E%20%20%20%20%3Cli%3E%3Cstrong%3EZip%20Code%3A%3C%2Fstrong%3E%20%3Cstrong%3E10003%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EPhone%3A%3C%2Fstrong%3E%20%3Cstrong%3E111-111-1111%3C%2Fstrong%3E%3C%2Fli%3E%20%3Cli%3E%3Cstrong%3EEmail%3A%3C%2Fstrong%3E%20%3Cstrong%3Emark_00000002_%40beltanenyc.com%3C%2Fstrong%3E%3C%2Fli%3E%20%3C%2Ful%3E%20%20%3Cbr%20%2F%3E%20%20%22%2C%20%20%20%20%20%20%20%20%20%22subject%22%3A%20%22FIRM%20GAS%20Supply%20RFP%3A%20SLICK%20WATTS%20A%2FF%20Multiple%20Customers%7C%20Due%3A%20October%2031st%2C%202025%20%7C%20Q25304-114143247&subject=fasdf&fromEmailId=sys.alerts%40plexitech.com&ccEmailId=pkute%40plexitech.com`,
//       body,
//       {
//         timeout: 800000,
//       }
//     );
//     return response;
//   } catch (error) {
//     console.error("Error fetching publishBid:", error);
//   }
// };
const publishBid = async (
  userId,
  companyId,
  bidId,
  bidDealer,
  supplierIds,
  recipient,
  emailBody,
  subject,
  fromEmailId,
  ccEmailId,
  body,
  attachments = [] // array of File objects (if any)
) => {
  try {
    debugger;
    const formData = new FormData();

    // append each attachment if any
    body?.files.forEach((file) => {
      formData.append("files", file); // "files" should match your backend parameter
    });

    // Append text fields (convert array to multiple params if backend expects it)
    formData.append("bidId", bidId);
    formData.append("bidDealer", bidDealer);
    supplierIds.forEach((id) => formData.append("supplierIds", id));
    formData.append("recipient", recipient);
    formData.append("emailBody", emailBody);
    formData.append("subject", subject);
    formData.append("fromEmailId", fromEmailId);
    formData.append("ccEmailId", ccEmailId);

    // If your API accepts a text 'body' too
    if (body) formData.append("body", body);

    const response = await axiosInstance.post(
      `/bid/publishBid/${userId}/${companyId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 800000,
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error publishing bid:", error);
    throw error;
  }
};

// const publishBid = async (userId, companyId, body) => {
//   try {
//     const response = await axiosInstance.post(
//       `/bid/publishBid/${userId}/${companyId}`,
//       body,
//       {
//         timeout: 800000,
//       }
//     );
//     return response;
//   } catch (error) {
//     console.error("Error fetching publishBid:", error);
//   }
// };
const addBidSupplier = async (
  userId,
  companyId,
  bidId,
  billingTypeId,
  body
) => {
  try {
    const response = await axiosInstance.post(
      `/bid/addBidSupplier/${userId}/${companyId}/${bidId}/${billingTypeId}`,
      body
    );
    return response;
  } catch (error) {
    console.error("Error fetching addBidSupplier:", error);
  }
};
const getBidDetailsByBidIdSupplierUuid = async (bidId, supplierUuid) => {
  try {
    const response = await axiosInstance.get(
      `/bid/getBidDetailsByBidIdSupplierUuid/${bidId}/${supplierUuid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getBidDetailsByBidIdSupplierUuid:", error);
  }
};
const updateBidSupplierInfo = async (userId, companyId, bidId, body) => {
  try {
    const response = await axiosInstance.post(
      `/bid/updateBidSupplierInfo/${userId}/${companyId}/${bidId}`,
      body
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateBidSupplierInfo:", error);
  }
};
const optOutBidSupplier = async (bidId, supplierId, supplierUuid) => {
  try {
    const response = await axiosInstance.get(
      `/bid/optOutBidSupplier/${bidId}/${supplierId}/${supplierUuid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching optOutBidSupplier:", error);
  }
};
const optOutBidSupplierByAdmin = async (bidId, supplierId, supplierUuid) => {
  try {
    const response = await axiosInstance.get(
      `/bid/optOutBidSupplierByAdmin/${bidId}/${supplierId}/${supplierUuid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching optOutBidSupplier:", error);
  }
};

const getAllBidsForSupplier = async (userId, companyId) => {
  try {
    const response = await axiosInstance.get(
      `/bid/getAllBidsForSupplier/${userId}/${companyId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getAllBidsForSupplier:", error);
  }
};

const deleteBid = async (userId, companyId, bidId, reason) => {
  try {
    const response = await axiosInstance.get(
      `/bid/deleteBid/${userId}/${companyId}/${bidId}?reason=${reason}`
    );
    return response;
  } catch (error) {
    console.log("error in fetching deleteBid", error);
  }
};
const holdBid = async (userId, companyId, bidId) => {
  try {
    const response = await axiosInstance.get(
      `/bid/holdBid/${userId}/${companyId}/${bidId}`
    );
    return response;
  } catch (error) {
    console.log("Error in fetching holdBid", error);
  }
};
const cancelBid = async (userId, companyId, bidId) => {
  try {
    const response = await axiosInstance.get(
      `/bid/cancelBid/${userId}/${companyId}/${bidId}`
    );
    return response;
  } catch (error) {
    console.log("Error in fetching cancelBid", error);
  }
};
const getSupplierContacts = async (supplierId) => {
  try {
    const response = await axiosInstance.get(
      `/Supplier/getSupplier/${supplierId}`
    );
    return response;
  } catch (error) {
    console.log("Error in fetching getSupplierContacts", error);
  }
};
const optInBidSupplier = async (bidId, supplierId, supplierUuid) => {
  try {
    const response = await axiosInstance.get(
      `/bid/optInBidSupplier/${bidId}/${supplierId}/${supplierUuid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching optInBidSupplier:", error);
  }
};
const optInBidSupplierByAdmin = async (bidId, supplierId, supplierUuid) => {
  try {
    const response = await axiosInstance.get(
      `/bid/optInBidSupplierByAdmin/${bidId}/${supplierId}/${supplierUuid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching optInBidSupplierByAdmin:", error);
  }
};

export const BidService = {
  bidList,
  getCatogeryById,
  getAllAgent,
  getBidById,
  updateBid,
  getBidEntities,
  addBid,
  updateBidEntity,
  getBidAnnualEntities,
  addBidEntity,
  getEntityConsumptionHeaderByBidId,
  getAllSuppliers,
  getBidSupplierPriceLog,
  updateBidSupplierComment,
  updateBidInternalComment,
  updateBidCustomerComment,
  getAllSuppliersInfoByBidId,
  getAnnualEntityConsumptionByBidId,
  publishBid,
  addBidSupplier,
  getBidDetailsByBidIdSupplierUuid,
  updateBidSupplierInfo,
  optOutBidSupplier,
  optOutBidSupplierByAdmin,
  getAllBidsForSupplier,
  deleteBid,
  holdBid,
  cancelBid,
  getSupplierContacts,
  optInBidSupplierByAdmin,
  optInBidSupplier,
};
